import { Button } from '@qr-front/ui/components/Button'
import { useAtom, useSetAtom } from 'jotai'
import { atomWithReset } from 'jotai/utils'
import { useTranslations } from 'next-intl'

import {
	openingHoursStateAtom,
	sharedOpeningHoursStateAtom,
} from './openingHoursState'

export type OpeningHoursTab = 'am-pm' | '24h' | 'open-24h'

export const selectedTabAtom = atomWithReset<OpeningHoursTab>('am-pm')

export const TabNavigation = () => {
	const t = useTranslations()
	const [selectedTab, setSelectedTab] =
		useAtom<OpeningHoursTab>(selectedTabAtom)
	const setOpeningHoursData = useSetAtom(openingHoursStateAtom)
	const setSharedOpeningHoursData = useSetAtom(sharedOpeningHoursStateAtom)

	const handleTabClick = (e: React.MouseEvent, tab: OpeningHoursTab) => {
		e.preventDefault()

		setOpeningHoursData((prev) => ({
			...prev,
			isAm: tab === 'am-pm',
			isOpen247: tab === 'open-24h',
		}))

		setSharedOpeningHoursData((prev) => ({
			...prev,
			isAm: tab === 'am-pm',
			isOpen247: tab === 'open-24h',
		}))

		setSelectedTab(tab)
	}

	return (
		<div className="hide-scrollbar flex flex-wrap gap-2 overflow-x-auto tablet:gap-4">
			<Button
				visual={selectedTab === 'am-pm' ? 'default' : 'secondary'}
				size="default"
				onClick={(e) => handleTabClick(e, 'am-pm')}
				className="type-body-medium flex-1 tablet:w-auto tablet:flex-none"
			>
				{t('generator__content_form_section__opening_hours__tabs__am_pm')}
			</Button>
			<Button
				visual={selectedTab === '24h' ? 'default' : 'secondary'}
				size="default"
				onClick={(e) => handleTabClick(e, '24h')}
				className="type-body-medium flex-1 tablet:w-auto tablet:flex-none"
			>
				{t('generator__content_form_section__opening_hours__tabs__24h_format')}
			</Button>
			<Button
				visual={selectedTab === 'open-24h' ? 'default' : 'secondary'}
				size="default"
				onClick={(e) => handleTabClick(e, 'open-24h')}
				className="type-body-medium hidden w-0 flex-1 tablet:inline-flex tablet:w-auto tablet:flex-none"
			>
				{t('generator__content_form_section__opening_hours__tabs__open_24h')}
			</Button>
			<Button
				visual={selectedTab === 'open-24h' ? 'default' : 'secondary'}
				size="default"
				onClick={(e) => handleTabClick(e, 'open-24h')}
				className="type-body-medium flex-1 tablet:hidden"
			>
				{t(
					'generator__content_form_section__opening_hours__tabs__open_24h_mobile',
				)}
			</Button>
		</div>
	)
}
